// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card_number[data-v-16c39101]{background-color:var(--card-number);border-radius:3px;height:22px;padding:0 3px}.card-name[data-v-16c39101]{font-size:18px}.card-collection[data-v-16c39101],.card-name[data-v-16c39101]{overflow:hidden;text-align:center;text-overflow:ellipsis;white-space:nowrap;width:100%}.small[data-v-16c39101]{width:170px}.small .main-img[data-v-16c39101]{height:140px}.small .card-name[data-v-16c39101]{font-size:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
